const PREFERS_REDUCED_MOTION = window.matchMedia("(prefers-reduced-motion: reduce)").matches

export const prefersReducedMotion = () => {
  return PREFERS_REDUCED_MOTION
}
